import { PLPHeroBannerData } from './types';
import { usePLPHeroBannerViewModel } from './usePLPHeroBannerViewModel';
import { ReactNode } from 'react';
import MiniReviews from '../Reviews/MiniReviews/MiniReviews';
import { MARKS } from '@contentful/rich-text-types';
import { localizeInCityToken } from '@/lib/utils/localizeInCityToken';
import { RichText } from '../RichText/RichText';
import type { OfferCardData } from '../OfferCard/types';
import PLPOfferCard from '../OfferCard/PLPOfferCard';

const PLPHeroBannerDefault = ({
  data,
  onOpen,
}: {
  data: PLPHeroBannerData;
  onOpen: (offer: OfferCardData) => void;
}) => {
  const vm = usePLPHeroBannerViewModel(data);

  const offer = vm.offerCardData;

  return (
    <section className='w-full bg-global-brand-primary bg-(image:--primary-gradient)'>
      {' '}
      <div className='content-box px-6 xl:px-0 mx-auto max-w-[1248px] py-6 lg:py-16'>
        {' '}
        <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-x-24 items-center max-lg:justify-items-center'>
          {' '}
          <div
            className={`max-w-161 transition-opacity duration-50 ${vm.isLocationLoading ? 'opacity-0' : 'opacity-100'}`}
          >
            {vm.titleRichTextData && <RichText data={{ ...vm.titleRichTextData }} />}{' '}
            {vm.copy ? (
              <div className='first-letter:uppercase'>
                <RichText
                  data={{
                    content: vm.copy,
                    className: `
					[&_p]:text-white
					[&_p]:text-[18px]
					[&_p]:leading-[160%]
					[&_p]:mb-8
					[&_p:last-child]:mb-0
				`,
                    options: {
                      renderMark: {
                        [MARKS.BOLD]: (text: ReactNode) => (
                          <strong className='text-plp-hero-highlighted-text'>{text}</strong>
                        ),
                      },
                      renderText: (text: string) => localizeInCityToken(text, vm.localizedCity),
                    },
                  }}
                />
              </div>
            ) : null}
            <div className='mt-8 max-lg:justify-center hidden lg:flex'>
              <MiniReviews />
            </div>
          </div>
          <div className='w-full flex max-lg:justify-center lg:justify-end'>
            <div className='relative w-full max-w-161'>
              {offer ? (
                <PLPOfferCard
                  data={offer}
                  onOpen={onOpen}
                  availabilityBadge={vm.availabilityBadge}
                  offerTitleRichTextData={vm.offerTitleRichTextData}
                  offerTitleText={vm.offerTitleText}
                  offerTeaserRichTextData={vm.offerTeaserRichTextData}
                  offerTeaserText={vm.offerTeaserText}
                  callRailPhone={vm.callRailPhone}
                  phoneHref={vm.phoneHref}
                  secondaryCtaLabel={vm.secondaryCtaLabel}
                  primaryCtaLabel={vm.primaryCtaLabel}
                />
              ) : null}
            </div>
          </div>
          <div className='flex max-lg:justify-center lg:hidden'>
            <MiniReviews />
          </div>
        </div>
      </div>
    </section>
  );
};
export default PLPHeroBannerDefault;
